
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","stroke-width":"1.5","fill":"none","xmlns":"http://www.w3.org/2000/svg","color":"#000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 12.5a.5.5 0 100-1 .5.5 0 000 1zm-6 0a.5.5 0 100-1 .5.5 0 000 1zm-6 0a.5.5 0 100-1 .5.5 0 000 1z","fill":"#000","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    